import type { CompareOverviewRecord } from '@/services/SalesforceService';
import { FilterFacade } from '@/modules/filter/core/FilterFacade';
import CachedCompareOverviewReader from '@/composables/useRecords/CachedCompareOverviewReader';
import type { CompareOverviewReaderIterator } from './interfaces';
import PageSeparator from './PageSeparator';
import CancelToken from './CancelToken';

export default class FilterCompareOverviewReader {
  private iterator: CompareOverviewReaderIterator;

  constructor(
    private readonly cachedReader: CachedCompareOverviewReader,
    private readonly filterFacade: FilterFacade<CompareOverviewRecord>
  ) {
    this.cachedReader.resetIterator();
    const self = this;
    this.iterator = (async function* generator() {
      for await (const compareOverviewRecord of self.cachedReader.getIterator()) {
        if (compareOverviewRecord instanceof PageSeparator) {
          yield compareOverviewRecord;
          continue;
        }

        if (compareOverviewRecord instanceof CancelToken) {
          yield compareOverviewRecord;
          continue;
        }

        if (self.isFiltered(compareOverviewRecord)) {
          continue;
        }

        yield compareOverviewRecord;
      }
    })();
  }

  getIterator(): CompareOverviewReaderIterator {
    return this.iterator;
  }

  cancel(): void {
    this.cachedReader.cancel();
  }

  private isFiltered(compareOverviewRecord: CompareOverviewRecord): boolean {
    const filterResult = this.filterFacade.filter(compareOverviewRecord);
    if (filterResult === false) {
      return true;
    }

    return false;
  }
}
